import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { parseTableQuery, buildTableQuery } from '../utils/tableQuery';

/**
 * Фильтры, быстрый поиск и страница списка — в адресной строке.
 *
 * Без этого уход в карточку и «назад» возвращали менеджера на первую страницу
 * пустого списка: состояние жило только в стейте страницы и умирало вместе с ней.
 *
 * Хука два, потому что порядок вызовов в компоненте обратный связи между ними:
 * значениями из адреса инициализируется стейт (значит, читать адрес надо ДО
 * useState), а писать в адрес нужно уже готовый стейт.
 */

/** Разбор адреса — один раз при монтировании: дальше адрес пишем мы сами. */
export const useInitialTableQuery = (filterNames) => {
  const [searchParams] = useSearchParams();
  return useRef(parseTableQuery(searchParams, filterNames)).current;
};

/** Запись текущего состояния в адрес. */
const useTableUrlSync = ({ queryParams, page, pageSize }) => {
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    // replace, а не push: иначе «назад» пришлось бы жать столько раз, сколько
    // полей менеджер потрогал.
    setSearchParams(buildTableQuery(queryParams, page, pageSize), { replace: true });
  }, [queryParams, page, pageSize]);
};

export default useTableUrlSync;
